export default __webpack_public_path__ + "static/media/Mindly-wireframe.b9d0fd53.png";